export let options = {
    cache: {},
    defaults: {
        minLength: 3,
        delay: 300,
        source: function(request, response) {
            let term = request.term;
            if (term in options.cache) {
                response(options.cache[term]);
                return;
            }
            $.getJSON("/api/course/names", request, function(data, status, xhr) {
                options.cache[term] = data;
                response(data);
            });
        }
    }
}